<template>
    <ListItemButton
        v-if="!anonymousSession"
        dusk="listsButton"
        data-action="lists"
        class="ReaderPromoteAppButton"
        :disabled="isOffline"
        icon-name="add-to-list"
        @click="toggleShowAddToLists"
    >
        <span>
            {{ localizations[lang].addToAList }}
        </span>
    </ListItemButton>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import ListItemButton from './list/ListItemButton.vue';

export default {
    components: {
        ListItemButton,
    },
    props: {
        width: {
            type: String,
            default: '18px',
        },
        height: {
            type: String,
            default: '18px',
        },
    },
    computed: {
        ...mapState(['anonymousSession', 'localizations', 'lang', 'isOffline']),
    },
    methods: {
        ...mapMutations(['toggleShowAddToLists']),
    },
};
</script>
